import { render, staticRenderFns } from "./Responders.vue?vue&type=template&id=72590582&scoped=true"
import script from "./Responders.vue?vue&type=script&lang=js"
export * from "./Responders.vue?vue&type=script&lang=js"
import style0 from "./Responders.vue?vue&type=style&index=0&id=72590582&prod&scoped=true&lang=css"
import style1 from "./Responders.vue?vue&type=style&index=1&id=72590582&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72590582",
  null
  
)

export default component.exports